import { Component, Input, OnInit, input } from '@angular/core';

export interface PeriodicElement {
  name: string;
  description: string;
  startTime: number;
  endTime: number;
  active: boolean;
  more?: any;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    description: '1',
    name: 'Hydrogen',
    startTime: 1.0079,
    endTime: 1,
    active: true,
  },
  {
    description: '2',
    name: 'Helium',
    startTime: 4.0026,
    endTime: 2,
    active: true,
  },
  {
    description: '3',
    name: 'Lithium',
    startTime: 6.941,
    endTime: 3,
    active: true,
  },
];
@Component({
  selector: 'app-org-app-table-skeleton',
  templateUrl: './org-app-table-skeleton.component.html',
  styleUrl: './org-app-table-skeleton.component.scss',
})
export class OrgAppTableSkeletonComponent implements OnInit{
  @Input('numberOfColumns') numberOfColumns: any;
  @Input('numberOfRows') numberOfRows: any;
  displayedColumns: string[] = [ ];
  columnsToDisplay:any
  dataSource :any;
  
  animation = 'pulse';
  ngOnInit() {
    const rowsCount = parseInt(this.numberOfRows, 10) || 0; // Fallback to 0 if conversion fails

    this.dataSource = new Array(rowsCount).fill({});
    for (let i = 0; i < this.numberOfColumns; i++) {
      this.displayedColumns.push('Column ' + (i + 1));
    }
    this.columnsToDisplay = [...this.displayedColumns, 'more'];
  }
}
